import { BtnLink } from "../shared/BtnLink"
import { Container } from "../shared/Container"
import { Paragraph } from "../shared/Paragraph"

export const CTA = () => {
  return (
    <section className="relative pb-20">
      {" "}
      <Container>
        <div className="relative overflow-hidden rounded-2xl">
          <div className="relative z-10 mx-auto max-w-xl px-6 py-8 text-center md:max-w-2xl md:px-8 md:py-10">
            <h1 className="text-heading-1 text-3xl font-bold sm:text-4xl md:text-5xl">
              {" "}
              <span className="bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent">
                Turbo charge
              </span>{" "}
              your practice now
            </h1>
            <Paragraph className="pt-10">
              Leverage TurboDVM to revolutionize your patient contact. Get data-driven insights and automation
              at your fingertips.
            </Paragraph>
            <div className="mx-auto max-w-md pt-10 sm:max-w-xl dark:text-white">
              <BtnLink text="Get Started" href="#" className="" />
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
